import { ApprovalRequiredAlert } from "@/components/reserve/Reserve/views/ApprovalRequiredAlert";
import { UserHealthRestrictedAlert } from "@/components/reserve/Reserve/views/UserHealthRestrictedAlert";
import React from "react";
import { ReserveProps } from "@/components/reserve/Reserve/types";
import { ReserveFormDates } from "@/components/reserve/Reserve/controls/ReserveFormDates";
import { ReserveFormStartTime } from "@/components/reserve/Reserve/controls/ReserveFormStartTime";
import { ReserveFormDuration } from "@/components/reserve/Reserve/controls/ReserveFormDuration";
import { ReserveFormResources } from "@/components/reserve/Reserve/controls/ReserveFormResources";
import { ReserveFormRestrictionAlerts } from "@/components/reserve/Reserve/views/ReserveFormRestrictionAlerts";
import { ReserveFormRecurring } from "@/components/reserve/Reserve/views/ReserveFormRecurring";
import { ReserveFormParking } from "@/components/reserve/Reserve/views/ReserveFormParking";
import { ReserveFormErrors } from "@/components/reserve/Reserve/views/ReserveFormErrors";
import { ReserveFormFloor } from "@/components/reserve/Reserve/views/ReserveFormFloor";
import { ReserveFormTimeZoneMismatchAlert } from "@/components/reserve/Reserve/views/ReserveFormTimeZoneMismatchAlert";
import { ReserveFormActions } from "@/components/reserve/Reserve/views/ReserveFormActions";
import { ReserveFormForm } from "@/components/reserve/Reserve/ReserveFormForm";
import { ReserveFormWeekDays } from "@/components/reserve/Reserve/views/ReserveFormWeekDays";
import { ReserveFormOtherUserReservation } from "@/components/reserve/Reserve/views/ReserveFormOtherUserReservation";
import { ReserveFormMeetingRoomUsers } from "@/components/reserve/Reserve/views/ReserveFormMeetingRoomUsers";
import { ReserveFormMeetingRoomTitle } from "@/components/reserve/Reserve/views/ReserveFormMeetingRoomTitle";
import { ReserveFormOnlineMeeting } from "@/components/reserve/Reserve/controls/ReserveFormOnlineMeeting";
import { ReserveFormWPRequests } from "@/components/reserve/Reserve/controls/ReserveFormWPRequests";
import { cn } from "@/lib/utils";
import { InputLabel } from "../components/InputLabel/InputLabel";
import { ReserveFormContext } from "@v2/reserve/ReverseFormContext";

export const Reserve: React.FC<ReserveProps> = ({
  onClose,
  showActions = true,
  isCompact = false
}) => {
  return (
    <>
      {onClose ? <ReserveFormTimeZoneMismatchAlert onClose={onClose} /> : null}
      <ReserveFormRestrictionAlerts />
      <UserHealthRestrictedAlert className="mb-2 max-w-xl" />
      <ApprovalRequiredAlert className="mb-2 max-w-xl" />
      <ReserveFormContext.Consumer>
        {(state) => {
          if (!state) return null;
          const { form, reservationDurationLabel, submitReservation } = state;
          const isRoom = state.resourceType === "meeting_room";
          return (
            <ReserveFormForm onSubmit={form.handleSubmit(submitReservation)}>
              <div className="flex flex-col gap-3">
                <ReserveFormOtherUserReservation />
                <div className="flex flex-col gap-4">
                  {/* Title */}
                  <div>
                    <ReserveFormMeetingRoomTitle />
                  </div>

                  {/* Date and time */}
                  <div className="flex flex-col items-start gap-2">
                    <div>
                      <InputLabel htmlFor="dates">Date & time</InputLabel>
                      <div>
                        <div className="grid grid-cols-12 gap-2">
                          <div className={"col-span-4"}>
                            <ReserveFormDates />
                          </div>
                          <div className={"col-span-4"}>
                            <ReserveFormStartTime />
                          </div>
                          <div className={"col-span-4"}>
                            <ReserveFormDuration />
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* <div className={''}>
                  Reservation duration: {reservationDurationLabel}
                </div> */}

                    <ReserveFormWeekDays />
                    <ReserveFormRecurring isCompact={isCompact} />
                  </div>

                  {/* Floor, Resources, Parking */}
                  <div className={cn("flex flex-col gap-1")}>
                    <div className={cn(isCompact && "hidden")}>
                      {!isCompact && (
                        <InputLabel htmlFor="floor">
                          Location & workspace
                        </InputLabel>
                      )}
                      <ReserveFormFloor />
                    </div>
                    <div
                      className={cn(
                        "relative text-left",
                        isCompact && "hidden"
                      )}
                    >
                      <ReserveFormResources />
                    </div>
                    <ReserveFormParking />
                  </div>

                  {/* Guests */}
                  {isRoom && (
                    <div>
                      <InputLabel htmlFor="guests">Add Guests</InputLabel>
                      <ReserveFormMeetingRoomUsers
                        defaultUsers={state.defaultValues.users}
                      />
                    </div>
                  )}

                  {isRoom && (
                    <div>
                      <ReserveFormOnlineMeeting
                        isEdit={false}
                        isMinimalistic={true}
                      />
                    </div>
                  )}

                  <div>
                    <ReserveFormWPRequests
                      workplaceRequestItems={state.workplaceRequestItems}
                    />
                  </div>

                  <div>
                    <ReserveFormErrors />
                  </div>

                  <div>{showActions && <ReserveFormActions />}</div>
                </div>
              </div>
            </ReserveFormForm>
          );
        }}
      </ReserveFormContext.Consumer>
    </>
  );
};
